var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secondary-menu-nested"},[_c('ProfileModerateReveals')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }